import {openDB} from 'idb';

const DB_NAME = 'vuex-db';
const STORE_NAME = 'vuex-store';

const dbPromise = openDB(DB_NAME, 1, {
    upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
        }
    },
});

export const idbTransactionalStorage = {
    async getItem(key) {
        const db = await dbPromise;
        return db.get(STORE_NAME, key);
    },
    async setItem(key, value) {
        const db = await dbPromise;
        const tx = db.transaction(STORE_NAME, 'readwrite');
        await tx.store.put(value, key);
        await tx.done;
    },
    async removeItem(key) {
        const db = await dbPromise;
        const tx = db.transaction(STORE_NAME, 'readwrite');
        await tx.store.delete(key);
        await tx.done;
    },

};
function cleanUpState(state) {
    return JSON.parse(JSON.stringify(state));
}

export const saveState = async (key, value) => {
    try {
        const cleanState = cleanUpState(value);
        const db = await dbPromise;
        const tx = db.transaction(STORE_NAME, 'readwrite');
        await tx.store.put(cleanState, key);
        await tx.done;
    } catch (err) {
    }
};

export const restoreState = async (key) => {
    try {
        const db = await dbPromise;
        const value = await db.get(STORE_NAME, key);
        if (value) {
            value.loading = false;
            value.isHydrated = true;
            return value;
        }
        return {isHydrated: true};
    } catch (err) {
        console.error('[VuexPersist] ❌ Error restoring state:', err);
        return {};
    }
};
